import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { getApi } from '../../api/endpoints';
import Page from "../Page";
import FormPartial from "./FormPartial";
import PageContentWrapper from "../../components/PageContentWrapper";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import CrmUser from '../../models/CrmUser';
import { toast } from 'react-toastify';


const Edit = (props) => {
  const [crmUser, setCrmUser] = useState((new CrmUser()).toStateJson());
  const [fetchApi] = getApi('showCrmUser');
  const [updateApi] = getApi('updateCrmUser');
  const navigate = useNavigate();


  const params = useParams();

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setCrmUser((new CrmUser(response.data.crm_user)).toStateJson());
    } catch(error) {
      toast.error(error.data.message || "Something went wrong")
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/crm/users");
      toast.success("Updated Successfully")
    } catch(error) {

    }
  }

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const onUpdateClick = () => {
    updateRecord((new CrmUser(crmUser)).toApiJson())
  }

  const onBackClick = () => {
    navigate("/crm/users")
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditCrmUserPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "CRM Users", url: '/crm/users' }, { label: "Edit" }]}
    className={'crm-users-page'}
  >
    <PageContentWrapper contentHeading={"CRM Users"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial crmUser={crmUser} setCrmUser={setCrmUser}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>Update User</button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
